import React from "react";
import { REVENUE_CHART_LEGEND_GAP } from "./constants";

export type ChartLegendItem = {
  key: string;
  label: string;
  color: string;
};

interface RevenueChartLegendProps {
  items: ChartLegendItem[];
}

export const RevenueChartLegend: React.FC<RevenueChartLegendProps> = ({
  items,
}) => {
  return (
    <ul
      className="flex h-4 w-full flex-wrap items-center justify-center"
      style={{ gap: REVENUE_CHART_LEGEND_GAP }}
    >
      {items.map((item) => (
        <li key={item.key} className="flex items-center gap-2">
          <span
            className="size-4 shrink-0 rounded-sm"
            style={{ backgroundColor: item.color }}
            aria-hidden
          />
          <span className="text-sm leading-none text-[#171717]">
            {item.label}
          </span>
        </li>
      ))}
    </ul>
  );
};
